/* eslint-disable */
import React, { useState } from "react";
import GenericInput from "@ui-components/Input/GenericInput";
import GenericButton from "@ui-components/Button/GenericButton";
import CustomRadioGroup, { CustomRadioOption } from "@ui-components/RadioGroup/CustomRadioGroup";
import GenericDropdown from "@ui-components/Dropdown/GenericDropdown";
import { ReactComponent as IconDelete } from "../../../../../shared/assets/Icons/IconDelete_KE.svg";
import GenericCard from "@ui-components/Card/GenericCard";
import InboundContent from "./InboundContent";
import OutboundContent from "./OutboundContent";

const POLICY_SELECTION_OPTIONS: CustomRadioOption[] = [
  { value: "specific", label: "Select specific routing tables" },
  { value: "dynamic", label: "Dynamic detection with tag" },
];

const NEXT_HOP_SELECTION_OPTIONS: CustomRadioOption[] = [
  { value: "specific", label: "Select specific ENI" },
  { value: "dynamic", label: "Dynamic detection with tag" },
];

// Placeholder routing table options
const routingTableOptions = ["rtb-1234", "rtb-5678", "rtb-9012"];
// Placeholder ENI options
const eniOptions = ["eni-1234", "eni-5678", "eni-9012"];

interface VRF {
  name: string;
  routeTargets: string[];
  newRouteTarget: string;
  routingTable: string;
  nextHopEni: string;
  policySelection: string;
  nextHopSelection: string;
  selectedRoutingTable?: string;
  selectedEni?: string;
  routingTableTagName?: string;
  routingTableTagValue?: string;
  nextHopTagName?: string;
  nextHopTagValue?: string;
  expanded: boolean;
}

interface PropagationTabContentProps {
  values: any;
  setValues: (v: any) => void;
  isTelco?: boolean;
  direction: "inbound" | "outbound";
  reflectorId?: number; // Add reflectorId prop
  clusterId?: number; // Add clusterId prop
  getAccessTokenSilently?: () => Promise<string>; // Add token function prop
}

const defaultVRF = (name: string): VRF => ({
  name,
  routeTargets: [],
  newRouteTarget: "",
  routingTable: "",
  nextHopEni: "",
  policySelection: "dynamic",
  nextHopSelection: "dynamic",
  expanded: true,
});

const PropagationTabContent: React.FC<PropagationTabContentProps> = ({ 
  values, 
  setValues, 
  isTelco = false, 
  direction,
  reflectorId,
  clusterId,
  getAccessTokenSilently
}) => {
  if (direction === "inbound") {
    return (
      <InboundContent 
        values={values} 
        setValues={setValues} 
        isTelco={isTelco}
        reflectorId={reflectorId}
        clusterId={clusterId}
        getAccessTokenSilently={getAccessTokenSilently}
      />
    );
  }
  if (direction === "outbound") {
    return (
      <OutboundContent 
        values={values} 
        setValues={setValues}
        reflectorId={reflectorId}
        clusterId={clusterId}
        getAccessTokenSilently={getAccessTokenSilently}
      />
    );
  }
  return null;
};

export default PropagationTabContent; 